const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://enessafoods.com';
const API_ENDPOINT = `${API_BASE_URL}/api`;

export const homepageAPI = {
  getHomepageData: async () => {
    try {
      const response = await fetch(`${API_ENDPOINT}/homepage/data/`);
      if (!response.ok) {
        throw new Error('Failed to fetch homepage data');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching homepage data:', error);
      throw error;
    }
  },

  getBanners: async () => {
    try {
      const response = await fetch(`${API_ENDPOINT}/homepage/banners/`);
      if (!response.ok) {
        throw new Error('Failed to fetch banners');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching banners:', error);
      throw error;
    }
  },

  getTestimonials: async () => {
    try {
      const response = await fetch(`${API_ENDPOINT}/homepage/testimonials/`);
      if (!response.ok) {
        throw new Error('Failed to fetch testimonials');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching testimonials:', error);
      throw error;
    }
  },

  getStats: async () => {
    try {
      const response = await fetch(`${API_ENDPOINT}/homepage/stats/`);
      if (!response.ok) {
        throw new Error('Failed to fetch stats');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching stats:', error);
      throw error;
    }
  },
  
  getServices: async () => {
    try {
      const response = await fetch(`${API_ENDPOINT}/services/`);
      if (!response.ok) {
        throw new Error('Failed to fetch services data');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching services data:', error);
      throw error;
    }
  },

  getProducts: async () => {
    try {
      const response = await fetch(`${API_ENDPOINT}/products/`);
      if (!response.ok) {
        throw new Error('Failed to fetch products data');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching products data:', error);
      throw error;
    }
  },

  getBlogs: async () => {
    try {
      const response = await fetch(`${API_ENDPOINT}/blogs/`);
      if (!response.ok) {
        throw new Error('Failed to fetch blogs data');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching blogs data:', error);
      throw error;
    }
  }
};